import dayjs from "dayjs";

/** `yyyy-MM-dd` for date inputs — avoids UTC split shifting calendar dates. */
export function toDateInputValue(value) {
  if (value == null || value === "") return "";
  const s = String(value);
  const match = s.match(/^(\d{4}-\d{2}-\d{2})/);
  if (match) return match[1];
  const d = dayjs(value);
  return d.isValid() ? d.format("YYYY-MM-DD") : "";
}

/** Parse API/DB calendar dates as local day — avoids UTC midnight showing as yesterday. */
export function parseCalendarDate(value) {
  if (value == null || value === "") return dayjs.invalid();
  const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (match) {
    const year = Number(match[1]);
    const month = Number(match[2]) - 1;
    const day = Number(match[3]);
    return dayjs(new Date(year, month, day));
  }
  const d = dayjs(value);
  return d.isValid() ? d.startOf("day") : dayjs.invalid();
}

/** Calendar date as YYYY-MM-DD for safe string comparisons. */
export function calendarDateIso(value) {
  return toDateInputValue(value);
}
